// src/pages/UsersPage.jsx
import React, { useState } from "react";
import AdminNavbar from "../components/AdminNavbar";
import UsersTable from "../components/UsersTable";
import UserMessages from "../components/UserMessages";
import { Box, Container } from "@mui/material";

export default function UsersPage({ token, onLogout }) {
  const [selectedUser, setSelectedUser] = useState(null);

  return (
    <>
      <AdminNavbar onLogout={onLogout} />
      <Container maxWidth="lg">
        <Box sx={{ mt: 4 }}>
          <UsersTable token={token} onSelectUser={setSelectedUser} />
        </Box>
        {selectedUser && (
          <UserMessages
            user={selectedUser}
            token={token}
            onClose={() => setSelectedUser(null)}
          />
        )}
      </Container>
    </>
  );
}
